import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4059d17a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(['umi_audio_info_bg', 'umi_audio_info_speaking_bg' ])
}
const _hoisted_2 = {
  key: 0,
  class: "listen_tips"
}
const _hoisted_3 = { style: {"text-align":"center"} }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.speakInfoSendState === 3 || _ctx.speakInfoSendState === 4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.umiName) + "正在" + _toDisplayString(_ctx.speakInfoSendState === 3 ? '思考' : '说话') + "中", 1),
          _createVNode(_component_van_button, {
            class: "close_button",
            onClick: _withModifiers(_ctx.closeUmiSpeak, ["stop"])
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: require('@/assets/image/umi_listen_close.svg'),
                class: "close_button_img"
              }, null, 8, _hoisted_4)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}